import { createAction, props } from '@ngrx/store';
import { IMetadataItemDto } from '../metadata-item.dto';
import { CONTACT_FIELDS_FEATURE_KEY, DOCUMENT_FIELDS_FEATURE_KEY } from './documentfields.config';

export const loadDocumentFields = createAction(
  `[${DOCUMENT_FIELDS_FEATURE_KEY}] Load Document Fields`,
  props<{ page: number }>()
);

export const loadDocumentFieldsSuccess = createAction(
  `[${DOCUMENT_FIELDS_FEATURE_KEY}] Load Document Fields Success`,
  props<{ documentFields: IMetadataItemDto[] }>()
);

export const loadDocumentFieldsFailure = createAction(
  `[${DOCUMENT_FIELDS_FEATURE_KEY}] Load Document Fields Failure`,
  props<{ error: string }>()
);

export const loadContactFields = createAction(
  `[${CONTACT_FIELDS_FEATURE_KEY}] Load Contact Fields`
);

export const loadContactFieldsSuccess = createAction(
  `[${CONTACT_FIELDS_FEATURE_KEY}] Load Contact Fields Success`,
  props<{ documentFields: IMetadataItemDto[] }>()
);

export const loadContactFieldsFailure = createAction(
  `[${CONTACT_FIELDS_FEATURE_KEY}] Load Contact Fields Failure`,
  props<{ error: string }>()
);

export const updateContactFields = createAction(
  `[${CONTACT_FIELDS_FEATURE_KEY}] Contact Fields Changed`
);

export const markContactFieldsStale = createAction(
  `[${CONTACT_FIELDS_FEATURE_KEY}] Mark Contact Fields Stale`
);
